import coupler from 'utils/coupler'
import withRouter from 'utils/withRouter'

import handlers, { initialState } from 'handlers/login'

const inputs = [
  { type: 'email', name: 'email', placeholder: 'Email' },
  { type: 'password', name: 'password', placeholder: 'Password' }
]

function render() {
  const { handle, state } = this
  return (
    <div className='container center'>
      <form className='form col-3' onSubmit={handle.submit}>
        { inputs.map(e =>
          <input {...e} className='col-12' onChange={handle.change} value={state[e.name]} />
        ) }
        <button className='col-12'>Login</button>
        { state.error && <div className='error-box'>{ state.error }</div> }
      </form>
    </div>
  )
}

export default withRouter(coupler({ handlers, initialState, render }))
